<style>
  .root {
    position: fixed;
    top: 0;
    right: 0;
    padding: 0.5rem;
    color: rgba(0,0,0,0.58);
    border-bottom-left-radius: 0.5rem;
    background-color: rgba(255,255,255, 0.3);
    font-family: 'Courier New', Courier, monospace;
    border: none;
  }
</style>
<script>
import { version } from '../swStore';
</script>

<button class="root" on:click>
  {$version}
</button>
